module.exports = __webpack_public_path__ + "img/2.a33f68fe.jpg";